module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lEG4d"))).then(() => parcelRequire('1iHdE'));